// GA4-события по «Wepurplay Stats v2» (game_start / game_complete / card_reached /
// store_click). gtag.js подключается в public/index.html ТОЛЬКО на wepurplay.com —
// на wepurplay.ru (там Яндекс.Метрика) и localhost window.gtag нет, поэтому все
// вызовы идут через эту обёртку и молча превращаются в no-op.
export default function trackEvent(name, params) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (e) {
    // аналитика никогда не должна ронять продуктовый флоу
  }
}

// store_name для события store_click: человекочитаемое имя магазина из URL
// (хост без www: pinkrabbit.ru, orion.de, …)
export function storeNameFromUrl(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch (e) {
    return null;
  }
}
